import { Pipe, PipeTransform } from '@angular/core';
export class WordsPipe implements PipeTransform {
/**
 * @param {?} value
 * @param {?=} args
 * @return {?}
 */
transform(value: string, args: number = 4): string {
    let /** @type {?} */ res = value;
    if (value && args > 0) {
      const /** @type {?} */ valueWords = value.split(/\s+/);
      if (valueWords.length > args) {
        res = valueWords.slice(0, args).join(' ') + '…';
      }
    }
    return res;
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{
  name: 'words'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function WordsPipe_tsickle_Closure_declarations() {
/** @type {?} */
WordsPipe.decorators;
/**
 * @nocollapse
 * @type {?}
 */
WordsPipe.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
